/**
 * Feature flags for controlling feature visibility
 * These flags allow features to be re-enabled for users later without major refactoring
 * 
 * When set to false: Only admins can see/access the feature
 * When set to true: All authenticated users can see/access the feature
 */
export const featureFlags = {
  // Reference Mode - Browse reference material and support resources
  referenceEnabledForUsers: false,
  
  // Training Mode - Access training workflows and simulations
  trainingEnabledForUsers: false,
  
  // Knowledge Check - Test knowledge with assessments and quizzes
  knowledgeCheckEnabledForUsers: false,
};

export default featureFlags;
